import React, {useContext, useEffect, useRef, useState} from 'react';
import {PicturesContext} from 'util/image/PictureContext';
import {useParams} from 'react-router-dom';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import ShareCanvas from 'components/pictures/share/ShareCanvas';
import ScreenShotCanvas from 'components/pictures/share/ScreenShotCanvas';
import 'styles/pictures/share/ShareImage.css';
import TransparencySlider from 'components/pictures/share/TransparencySlider';
import NiceButton from "../NiceButton";

const ShareImage = () => {
    const {imageId} = useParams();
    const {allPictures, sortedByAmount, sortedByTrending} = useContext(PicturesContext);
    const [imageData, setImageData] = useState(null);
    const [imageRanks, setImageRanks] = useState({top: null, trending: null});
    const [items, setItems] = useState(['logo', 'pricetag', 'fire', 'trophy']);
    const [selectedItem, setSelectedItem] = useState(null);
    const shareRef = useRef();
    const [showLetters, setShowLetters] = useState(true);
    const [resetKey, setResetKey] = useState(0);
    const [transparencies, setTransparencies] = useState(null);
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    useEffect(() => {
        setTransparencies(initialTransparencies());
    }, []);

    useEffect(() => {
        if (!allPictures.length || !sortedByAmount.length || !sortedByTrending.length) {
            return;
        }

        const picture = allPictures.find((pic) => pic.id === imageId);
        if (picture) {
            setImageData(picture);

            console.log('sorted by amount: ', sortedByAmount.map((pic) => pic.id));
            const topIndex = sortedByAmount.findIndex((pic) => pic.id === imageId);
            console.log('topIndex: ', topIndex, '  imageId: ', imageId);
            const trendingIndex = sortedByTrending.findIndex((pic) => pic.id === imageId);

            setImageRanks({
                top: topIndex + 1,
                trending: trendingIndex + 1,
            });
        } else {
            console.error('Image not found');
        }
    }, [imageId, allPictures, sortedByAmount, sortedByTrending]);

    useEffect(() => {
        if (!selectedItem) {
            return;
        }

        setItems((prevItems) => {
            const newItems = prevItems.filter((i) => i !== selectedItem);
            return [...newItems, selectedItem];
        });
    }, [selectedItem]);

    useEffect(() => {
        const handleMouseDown = (event) => {
            const imageContainer = document.getElementById('image-container');
            const rndElements = document.querySelectorAll('.parent-div-draggable');
            let clickedImageId = null;
            rndElements.forEach((element) => {
                if (element.contains(event.target)) {
                    clickedImageId = element.id;
                }
            });

            console.log('clickedAnyImage: ', clickedImageId);

            if (!imageContainer || !imageContainer.contains(event.target)) {
                console.log('outside');
                return;
            }

            if (!clickedImageId) {
                setSelectedItem(null);
            }
        };

        document.addEventListener('mousedown', handleMouseDown);
        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, [selectedItem]);

    const callShare = () => {
        if (shareRef.current && isImageLoaded) {
            shareRef.current.shareImage();
        }
    };


    const initialTransparencies = () => {
        return {
            'fire': 0.75,
            'trophy': 0.9,
            'pricetag': 0.9,
            'logo': 0.7,
        };
    };

    const onResetClick = () => {
        setResetKey((prev) => prev + 1);
        setTransparencies(initialTransparencies());
    };

    const handleChange = (item, value) => {
        if (item === 'logo') {
            value = Math.max(value, 0.3);
        }
        setTransparencies((prev) => ({...prev, [item]: value}));
        setSelectedItem(item);
    };

    if (!imageData || imageRanks.top === null || imageRanks.trending === null) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <UniversalEmptyPageHeader image={'share'} text={'Share Image'} desktopText={true} click={callShare}/>
            <div className="main-content-body-padding">
                <ScreenShotCanvas selectedItem={selectedItem} setSelectedItem={setSelectedItem} ref={shareRef}
                                  isImageLoaded={isImageLoaded}/>

                <div style={{paddingBottom: 12}}>
                    <ShareCanvas
                        imageData={imageData}
                        imageRanks={imageRanks}
                        items={items}
                        selectedItem={selectedItem}
                        setSelectedItem={setSelectedItem}
                        showLetters={showLetters}
                        resetKey={resetKey}
                        transparencies={transparencies}
                        onImageLoad={() => setIsImageLoaded(true)}
                    />
                </div>

                {isImageLoaded && (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        maxWidth: 400,
                        backgroundColor: '#fafafa',
                        padding: '4px 12px 12px 12px',
                        borderRadius: '12px',
                        border: '1px solid #ddd'
                    }}>
                        <div>
                            {Object.keys(transparencies).map((item) => (
                                <TransparencySlider
                                    key={item}
                                    label={item}
                                    value={transparencies[item]}
                                    onChange={(value) => handleChange(item, value)}
                                />
                            ))}
                        </div>
                        <div style={{display: 'flex', gap: 8, marginTop: 8, alignSelf: 'center'}}>
                            <NiceButton onClick={() => setShowLetters(!showLetters)}
                                        text={`${showLetters ? 'Hide' : 'Show'} Letters`}/>

                            <NiceButton onClick={onResetClick} text={'Reset'}/>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ShareImage;
